var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-title",style:({'width': _vm.width+'px'||'auto'})},[_c('div',{staticClass:"d-title-line"}),_vm._v("\n  "+_vm._s(_vm.text)),(_vm.tip)?_c('span',{staticClass:"tip"},[_vm._v(_vm._s(_vm.tip))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }